const dev = {
  env: 'DEV' as const,
  BASE_URL: 'https://uu6tvasc0i.execute-api.eu-west-1.amazonaws.com/dev',
  IMAGE_BASE:
    'https://challenge-accepted-mob.s3.eu-west-2.amazonaws.com/challenges-dev',
  CAROUSEL_BASE:
    'https://challenge-accepted-mob.s3.eu-west-2.amazonaws.com/carousel-dev',
};

const preprod = {
  env: 'PREPROD' as const,
  BASE_URL: 'https://api.challengeacceptedapp.com/private-admin-preprod',
  IMAGE_BASE:
    'https://challenge-accepted-mob.s3.eu-west-2.amazonaws.com/challenges-preprod',
  CAROUSEL_BASE:
    'https://challenge-accepted-mob.s3.eu-west-2.amazonaws.com/carousel-preprod',
};

const prod = {
  env: '' as const,
  BASE_URL: 'https://api.challengeacceptedapp.com/private-admin-prod',
  IMAGE_BASE:
    'https://challenge-accepted-mob.s3.eu-west-2.amazonaws.com/challenges-prod',
  CAROUSEL_BASE:
    'https://challenge-accepted-mob.s3.eu-west-2.amazonaws.com/carousel-prod',
};

const stage = import.meta.env.VITE_APP_STAGE;

const config =
  stage === 'preprod' ? preprod : stage === 'prod' ? prod : dev;

export type AppConfig = typeof config;

export default config;
